module.exports = __webpack_public_path__ + "img/placket length.34deba52.png";